import { asyncTypes } from 'store/_helpers';

const TYPES = {
  ...asyncTypes('GET_FUEL_VISIBILITY'),
  ...asyncTypes('UPDATE_FUEL_VISIBILITY')
};

export default TYPES;
